import { render, staticRenderFns } from "./ListaIncidencias.vue?vue&type=template&id=bf5468f8&"
import script from "./ListaIncidencias.vue?vue&type=script&lang=js&"
export * from "./ListaIncidencias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports